/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const usePgHbaCardStyles = makeStyles(theme => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    marginLeft: '-24px',
    '&:hover': {
      '& > $deleteIcon': {
        display: 'inline-flex',
      },
    },
  },
  row: {
    cursor: 'move',
    maxWidth: '864px',
    flex: '0 0 864px',
    paddingLeft: '24px',
    '&:hover:not(:active)': {
      '& > $dragIcon': {
        display: 'inline-flex',
      },
    },
    '&:hover:active': {
      '& > $dragIcon': {
        display: 'none',
      },
    },
  },
  rowItem: {
    padding: '9px 8px',
    borderBottom: '1px solid #EEEEEE',
  },
  formControl: {
    border: '1px solid #EEEEEE',
    padding: '8px 10px',
    borderRadius: '6px',
    '& > input': {
      padding: 0,
      color: '#41404A',
      fontSize: '14px',
      lineHeight: '14px',
      letterSpacing: '-0.11px',
      height: '14px',
    },
  },
  selectFormControl: {
    width: '100%',
  },
  formSelect: {
    '& .MuiSelect-select': {
      border: '1px solid #EEEEEE',
      padding: '4px 32px 4px 10px',
    },
    borderRadius: '6px',
    color: '#41404A',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '-0.11px',
  },
  formIcon: {
    color: theme.palette.graphicElements.main,
  },
  formIconError: {
    color: theme.palette.error.main,
  },
  dragIcon: {
    display: 'none',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    margin: 'auto',
  },
  deleteIcon: {
    marginLeft: '8px',
    cursor: 'pointer',
    display: 'none',
  },
  autocompleteClear: {
    right: '9px',
  },
  autocompleteChipRoot: {
    background: 'transparent',
    height: '14px',
    margin: '0',
  },
  autocompleteChipRootMultiple: {
    margin: '3px 3px 3px 0',
    height: '24px',
  },
  autocompleteChipLabel: {
    color: '#41404A',
    fontWeight: 400,
    padding: '0 12px 0 0',
  },
  autocompleteChipIcon: {
    display: 'none',
  },
  autocompleteInputRoot: {
    padding: '0 39px 0 10px',
    border: '1px solid #EEEEEE',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '14px',
    letterSpacing: '-0.11px',
    color: '#41404A',
    '& > $autocompleteInputMultiple': {
      width: '100%',
    },
  },
  autocompleteInputMultiple: {},
  formSelectError: {
    borderColor: theme.palette.error.main,
    backgroundColor: `${theme.palette.error.main}10`,
  },
  autocompleteOption: {
    '&:first-child': {
      marginBottom: '6px',
      borderBottom: '1px solid #A2A7AE',
      backgroundColor: '#fff',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      },
    },
  },
  errorLine: {
    color: theme.palette.error.main,
    margin: '2px',
  },
}));
